/**
 * State used in rendering Persona
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
